// TODO: Create custom toast in wangs-ui to replace primevue toast
<script setup lang="ts">
import Toast, {
  ToastMessageOptions as PrimeToastMessageOptions,
} from 'primevue/toast';
import { onBeforeMount, onBeforeUnmount, onMounted, shallowRef } from 'vue';

import Icon from 'lib/components/icon/Icon.vue';
import {
  ToastEmits,
  ToastMessageOptions,
  ToastProps,
  ToastSeverity,
} from 'lib/components/toast/Toast.vue.d';
import eventBus from 'lib/event-bus';

const props = withDefaults(defineProps<ToastProps>(), {
  position: 'bottom-right',
  group: 'default-toast',
  baseZIndex: 9980,
});

defineEmits<ToastEmits>();

onMounted(() => {
  eventBus.on('toast:add', handleToastAdd);
});

onBeforeMount(() => {
  if (window.toastGroups && window.toastGroups.includes(props.group)) {
    renderToast.value = false;
  } else {
    window.toastGroups = [props.group, ...(window.toastGroups ?? [])];
    renderToast.value = true;
  }
});

onBeforeUnmount(() => {
  window.toastGroups = window.toastGroups?.filter(
    (group) => group !== props.group,
  );

  eventBus.off('toast:add', handleToastAdd);
});

const toastMessageOptions = shallowRef<ToastMessageOptions>();
const renderToast = shallowRef<boolean>(false);

const handleToastAdd = (params: ToastMessageOptions): void => {
  if (params.group === props.group) toastMessageOptions.value = params;
  if (params.error) console.error(params.error);
};

const convertMessageOptions = (
  options: PrimeToastMessageOptions,
): ToastMessageOptions => {
  return {
    message: options.detail,
    life: options.life,
    severity: options.severity as ToastSeverity,
    group: options.group,
  };
};
</script>

<template>
  <Toast
    v-if="renderToast"
    v-bind="$props"
    :data-group="$props.group"
    @close="$emit('close', convertMessageOptions($event))"
    @life-end="$emit('lifeEnd', convertMessageOptions($event))"
  >
    <template #icon>
      <Icon
        v-if="toastMessageOptions?.icon"
        :class="['w-5 h-5 text-inherit', toastMessageOptions?.iconClass]"
        :icon="toastMessageOptions?.icon"
      />
    </template>

    <template
      #container="{ message, closeCallback }"
      v-if="$slots['container']"
    >
      <slot
        :close-callback="closeCallback"
        :message="message"
        name="container"
      />
    </template>

    <template #message="{ message }" v-if="$slots['message']">
      <slot :message="message" name="message" />
    </template>
  </Toast>
</template>
